/**
 * @generated SignedSource<<f915dd2c1720b6298116187c160f6d70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamLink_info$data = {
  readonly archived: boolean;
  readonly id: string;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "TeamLink_info";
};
export type TeamLink_info$key = {
  readonly " $data"?: TeamLink_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamLink_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamLink_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "35b59e9fbd27cad47fc967d50b1762e8";

export default node;
